import {supabase} from "../../../services/Supabase";

export const HubsService = {
    get: async function(id: string) {
        let { data, error } = await supabase
            .from('hubs')
            .select('*')
            .eq("id", id)
        return data
    },


    view: async function() {
        let { data, error } = await supabase
            .from('hubs')
            .select('*')
        return data
    },

    create: async function(site: any) {
        const { data, error } = await supabase
            .from('hubs')
            .insert([
                { id: site.id },
            ])
        return data
    },

    update: async function(id: string, site: any) {
        const { data, error } = await supabase
            .from('hubs')
            .update([
                { ...site },
            ])
            .eq('id', id)
        return data
    },

    remove: async function(id: string)  {
        const { data, error } = await supabase
            .from('hubs')
            .delete()
            .eq('id', id)
        return data
    }
}